import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import * as _ from "lodash";
import {RouteModel} from "../../../models/route.model";
import {get, reduce} from "lodash";

require('./routes-totals-bar.scss');
@Component({
  standalone: false,
  selector: 'app-routes-totals-bar',
  templateUrl: './routes-totals-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesTotalsBarComponent implements OnInit {

  @Input() routes: RouteModel[];

  public totals: {
    numberOfPackages?: number,
    weightLoad?: number,
    calculatedVolume?: number,
    totalDistanceMeter?: number
  }
  public aggregatedServiceIdList: string[] = [];
  public aggregatedPackageList: any = [];

  constructor(
    @Inject('$timeout') private $timeout
  ) {
  }

  ngOnInit() {
    this._setData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.routes && !changes.routes.isFirstChange()) {
      this._setData();
    }
  }

  private _setData() {
    this.totals = {};

    // Set Totals
    this.totals.numberOfPackages = reduce(this.routes, (sum, r: RouteModel) => sum + get(r, 'totalLoad.numberOfPackages', 0), 0);
    this.totals.weightLoad = reduce(this.routes, (sum, r: RouteModel) => sum + get(r, 'maxLoad.weightLoad', 0), 0);
    this.totals.calculatedVolume = reduce(this.routes, (sum, r: RouteModel) => sum + get(r, 'maxLoad.calculatedVolume', 0), 0);
    this.totals.totalDistanceMeter = reduce(this.routes, (sum, r: RouteModel) => sum + get(r, 'totalLoad.totalDistanceMeter', 0), 0);

    // Set Aggregated Services
    this.aggregatedServiceIdList = _.uniq(_.flatMap(this.routes, 'serviceIdList'));

    // Set Aggregated PackageList
    const allTasks = _.flatMap(this.routes, 'taskListExt');
    this.aggregatedPackageList = _.flatMap(allTasks, 'packageList[0]');

  }

}
